<template>
  <div>
    <ContentHeader title="Profile" />
    <profile-skeleton v-if="loading"></profile-skeleton>
    <section v-else class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body py-4 px-md-5">
            <div class="profile-container d-flex mb-4 position-relative">
              <button
                class="btn btn-menu change-password"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </button>

              <div
                class="dropdown-menu dropdown-menu-right mr-1"
                aria-labelledby="dropdownMenuButton"
              >
                <router-link
                  class="dropdown-item text-warning"
                  :to="{ name: 'UpdateProfile', params: { id: user.id } }"
                >
                  <i
                    class="fas fa-edit"
                    style="width: 20px; margin-right: 1rem"
                  ></i>
                  <b>Edit Profile</b>
                </router-link>
                <router-link
                  class="dropdown-item text-danger"
                  :to="{ name: 'ChangePassword', params: { id: user.id } }"
                >
                  <i
                    class="fas fa-key"
                    style="width: 20px; margin-right: 1rem"
                  ></i>
                  <b>Change Password</b>
                </router-link>
              </div>
              <img
                class="profile-image"
                :src="
                  user.image
                    ? user.image
                    : require('@/assets/image/default-profile.png')
                "
                alt="User profile picture"
              />

              <div
                class="p-md-3 mx-md-3 d-flex flex-column justify-content-center"
              >
                <h2 class="font-weight-bold">
                  {{ user.name }}
                </h2>

                <h5 class="fw-normal text-secondary">{{ user.email }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 px-md-3">
          <h3>User Info</h3>
          <div class="row" style="background: none">
            <div class="col-md-4">
              <div class="card p-3">
                <h5 class="font-weight-bold mb-1">Phone</h5>
                <p class="mb-0">{{ user.phone }}</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card p-3">
                <h5 class="font-weight-bold mb-1">Address</h5>
                <p class="mb-0">{{ user.address }}</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card p-3">
                <h5 class="font-weight-bold mb-1">Country</h5>
                <p class="mb-0">{{ user.country }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="card p-3">
                <h5 class="font-weight-bold mb-1">Person In Charge</h5>
                <p class="mb-0">{{ user.pic }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import ProfileSkeleton from "@/components/loading-screen/ProfileSkeleton.vue"

export default {
  components: {
    ContentHeader,
    ProfileSkeleton,
  },
  data() {
    return {
      loading: true,
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch('userDetail', this.$user_id)
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.response.data.data.massage,
        "error"
      );
    } finally {
      this.loading = false
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .profile-container {
    padding-top: 2rem;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
.profile-image {
  --image-size: 250px;
  width: var(--image-size);
  height: var(--image-size);
  border-radius: 100vh;
}
.change-password {
  position: absolute !important;
  top: 0;
  right: 0;
}
.btn-menu:hover {
  background-color: #f0f0f0;
}
.dropdown-item:focus,
.dropdown-item:hover {
  background-color: #f0f0f0 !important;
}
</style>